import { get, put } from './api';
import { WARRAPP_NOTIFICATIONS_API_URL } from 'config';
import {
  GetBannerMessagesResponseDTO,
  GetBannerMessagesResponseParamsDTO,
  GetNotificationsHistoryParamsDTO,
  GetNotificationsHistoryResponseDTO,
  GetPushNotificationsParamsDTO,
} from 'declarations/dto/notifications';

export const getPushNotificationsApi = ({ idToken, userId }: GetPushNotificationsParamsDTO) =>
  new WebSocket(
    `${WARRAPP_NOTIFICATIONS_API_URL}?Authorization=Bearer ${idToken}&UserId=${userId}`
  );

export const getNotificationsHistoryApi = async (params: GetNotificationsHistoryParamsDTO) => {
  const response = await get<GetNotificationsHistoryResponseDTO>(
    `/notifications/current-user`,
    params
  );

  return response.data;
};

export const updateNotificationHistoryStatusApi = async (notificationId: string) => {
  const response = await put<void>(`/notifications/${notificationId}/read`);

  return response.data;
};

export const updateNotificationsHistoryStatusApi = async () => {
  const response = await put<void>(`/notifications/all/as-read`);

  return response.data;
};

export const updateNotificationsRoofTopHistoryStatus = async (roofTopId: string) => {
  const response = await put<void>(`/notifications/${roofTopId}/as-read`);

  return response.data;
};

export const getBannerMessagesApi = async (params: GetBannerMessagesResponseParamsDTO) => {
  const response = await get<GetBannerMessagesResponseDTO>(`/banner-messages/current-user`, params);

  return response.data;
};
